// extracted by mini-css-extract-plugin
export default {"inputNumber":"InputNumber_inputNumber__s8hQ-","displayNumber":"InputNumber_displayNumber__pRi5y"};